import type { CompassCardComponentProps } from '@scale/compass-ui/types';
import type {
  CalendarDataGeneratorContext,
  Locale,
} from '@scale/genai-compass-shared/cards/calendar_data_generator';
import { Flex, Callout } from '@scale/scaleui-radix';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RowsToGenerateInput from './RowsToGenerateInput';
import LocaleSelector from './LocaleSelector';
import SamplingSettingsSection from './SamplingSettingsSection';
import ConfigurationSummary from './ConfigurationSummary';

export default function CalendarDataGeneratorCardComponent({
  context,
  updateCardContext,
}: CompassCardComponentProps<CalendarDataGeneratorContext>) {
  const handleRowsToGenerateChange = (value: number) => {
    updateCardContext({
      ...context,
      rowsToGenerate: value,
    });
  };

  const handleLocalesChange = (locales: Locale[]) => {
    updateCardContext({
      ...context,
      locales,
    });
  };

  const handleSamplingChange = (updates: Partial<CalendarDataGeneratorContext>) => {
    updateCardContext({
      ...context,
      ...updates,
    });
  };

  return (
    <Flex direction="column" gap="4">
      <Callout.Root color="blue" size="1">
        <Callout.Icon>
          <FontAwesomeIcon icon={faInfoCircle} />
        </Callout.Icon>
        <Callout.Text>
          This card generates synthetic calendar data for testing purposes. Configure the parameters
          below to customize the generated data.
        </Callout.Text>
      </Callout.Root>

      <RowsToGenerateInput
        value={context.rowsToGenerate || 100}
        onChange={handleRowsToGenerateChange}
      />

      <LocaleSelector value={context.locales || []} onChange={handleLocalesChange} />

      <SamplingSettingsSection context={context} onChange={handleSamplingChange} />

      <ConfigurationSummary context={context} />
    </Flex>
  );
}
